import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import { Link, useHistory } from 'react-router-dom';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const { REACT_APP_PROXY_HOST } = process.env;

function Operations() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [appareils, setAppareils] = useState([]);
  const [selectedTelId, setSelectedTelId] = useState('');
  const history = useHistory();
  const isMobile = size.height > size.width;
  const carteMedia = { height: '15rem' };
  const carte = { opacity: '0.8' };

  const handleWindowSizeChange = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  useEffect(() => {
    fetch(REACT_APP_PROXY_HOST + '/liste/appareils', { method: 'GET' })
      .then((res) => res.json())
      .then((data) => {
        setAppareils(data || []);
        if (data && data.length > 0) {
          setSelectedTelId(data[0].telId);
        }
      });
  }, []);

  const openSelectedAppareil = () => {
    if (!selectedTelId) {
      history.push('/appareils');
      return;
    }
    history.push('/appareils?telId=' + encodeURIComponent(selectedTelId));
  };

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}><Grid item xs={12} md={3}><Typography color="secondary" variant="h3">Operations SyncStats</Typography></Grid><Grid item xs={12} md={9} /></Grid>
      <Grid container spacing={5}>
        <Grid item xs={12} md={3}><Link to="/Operations/Tutoriels"><Card style={carte}><CardActionArea><CardMedia style={carteMedia} height='10px' /><CardContent><Typography gutterBottom variant="h5" component="h2">Tutoriels</Typography></CardContent></CardActionArea><CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions></Card></Link></Grid>
        <Grid item xs={12} md={3}><Link to="/Operations/Resoudre"><Card style={carte}><CardActionArea><CardMedia style={carteMedia} height='10px' /><CardContent><Typography gutterBottom variant="h5" component="h2">Resoudre un probleme client</Typography><Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography></CardContent></CardActionArea><CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions></Card></Link></Grid>
        <Grid item xs={12} md={3}><Link to="/Operations/Monitorer"><Card style={carte}><CardActionArea><CardMedia style={carteMedia} height='10px' /><CardContent><Typography gutterBottom variant="h5" component="h2">Monitorer l'activite</Typography><Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography></CardContent></CardActionArea><CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions></Card></Link></Grid>
        <Grid item xs={12} md={3}><Link to="/Operations/IncidentsCamera"><Card style={carte}><CardActionArea><CardMedia style={carteMedia} height='10px' /><CardContent><Typography gutterBottom variant="h5" component="h2">Incidents Camera</Typography><Typography variant="body2" color="textSecondary" component="p">Voir, regrouper et copier les sequences SyncCam utiles au debugging</Typography></CardContent></CardActionArea><CardActions><Button size="small" color="primary">Ouvrir</Button></CardActions></Card></Link></Grid>
        <Grid item xs={12} md={3}><Link to="/Operations/Preparer"><Card style={carte}><CardActionArea><CardMedia style={carteMedia} height='10px' /><CardContent><Typography gutterBottom variant="h5" component="h2">Preparer un nouveau client</Typography><Typography variant="body2" color="textSecondary" component="p">Ce sera votre "Intranet"</Typography></CardContent></CardActionArea><CardActions><Button size="small" color="primary">Laissez une note</Button></CardActions></Card></Link></Grid>
        <Grid item xs={12} md={3}><Link to="/appareils"><Card style={carte}><CardActionArea><CardMedia style={carteMedia} height='10px' /><CardContent><Typography gutterBottom variant="h5" component="h2">Logs / Sensors Appareils</Typography><Typography variant="body2" color="textSecondary" component="p">Acces direct aux graphiques et logs par appareil</Typography></CardContent></CardActionArea><CardActions><Button size="small" color="primary">Ouvrir</Button></CardActions></Card></Link></Grid>
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull" style={{ padding: 16 }}>
            <Typography variant="h5">Acces direct aux graphiques d'appareil</Typography>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 12, flexWrap: 'wrap' }}>
              <TextField
                select
                label="Appareil disponible"
                value={selectedTelId}
                onChange={(e) => setSelectedTelId(e.target.value)}
                style={{ minWidth: 300 }}
                variant="outlined"
                size="small"
              >
                {appareils.map((appareil) => (
                  <MenuItem key={appareil.telId} value={appareil.telId}>
                    {appareil.camId ? 'Cam ' + appareil.camId + ' - ' : ''}{appareil.telId}
                  </MenuItem>
                ))}
              </TextField>
              <Button variant="contained" color="primary" onClick={openSelectedAppareil}>
                Ouvrir Monitoring Appareil
              </Button>
              <Button variant="outlined" onClick={() => history.push('/appareils')}>
                Voir la liste complete
              </Button>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Operations;




// WEBPACK FOOTER //
// src/components/Operations.js